"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nativeCsvWriter = exports.nativeCsvWriterResultSchema = exports.nativeCsvWriterArgsSchema = exports.WriterSourceTypeSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
var nativeCsvReader_1 = require("./nativeCsvReader");
// Writer-specific source type that extends the base SourceTypeSchema with 'objects' variant
exports.WriterSourceTypeSchema = zod_1.z.discriminatedUnion('type', [
    zod_1.z
        .object({
        type: zod_1.z.literal('raw'),
        content: zod_1.z.string(),
    })
        .describe('Plain string field accepting CSV content.'),
    zod_1.z
        .object({
        type: zod_1.z.literal('url'),
        url: zod_1.z.string(),
    })
        .describe('URL field accepting CSV or XLSX content.'),
    zod_1.z
        .object({
        type: zod_1.z.literal('gsheet'),
        gsheetId: zod_1.z.string(),
        sheetId: zod_1.z.string(),
    })
        .describe('Google Spreadsheet ID (page) and Sheet ID (tab) field accepting CSV content.'),
    zod_1.z
        .object({
        type: zod_1.z.literal('objects'),
        objects: zod_1.z
            .array(zod_1.z.record(zod_1.z.unknown()))
            .describe('Array of objects with the same signature. Each object will be treated as a 1D object, with all values converted to strings or numbers and written as CSV rows.'),
    })
        .describe('Array of plain objects to convert to CSV.'),
]);
// Argument schema
exports.nativeCsvWriterArgsSchema = zod_1.z
    .object({
    sourceType: exports.WriterSourceTypeSchema.describe('The type of the source CSV. Determines how and where to write the data. Use "objects" type to write an array of plain objects.'),
    results: zod_1.z
        .array(nativeCsvReader_1.CsvDataRowSchema)
        .describe('The CSV data to write. Array of CsvDataRow objects, one for each row in the CSV.')
        .nullish(),
    filename: zod_1.z
        .string()
        .describe('Optional custom filename for the CSV file (without extension)')
        .nullish(),
    emitMode: common_1.emitModeSchema.default('single').describe('Default to "single".'),
})
    .refine(function (data) {
    if (data.sourceType.type === 'objects') {
        return true; // objects are in sourceType.objects
    }
    return data.results != null; // results must be provided for other source types (nullish check)
}, {
    message: 'Either use sourceType "objects" or provide "results" for other source types.',
    path: ['results'],
});
exports.nativeCsvWriterResultSchema = zod_1.z.discriminatedUnion('type', [
    zod_1.z.object({
        type: zod_1.z.literal('text'),
        content: zod_1.z.string(),
    }),
    zod_1.z.object({
        type: zod_1.z.literal('file'),
        fileType: zod_1.z.literal('csv'),
        filename: zod_1.z.string(),
        source: zod_1.z.object({
            kind: zod_1.z.union([zod_1.z.literal('raw'), zod_1.z.literal('url')]),
            value: zod_1.z.string(),
        }),
    }),
]);
// Tool definition
exports.nativeCsvWriter = (0, common_1.createEmitModeToolMetadata)({
    id: 'nativeCsvWriter',
    displayName: 'CSV Writer',
    displayDescription: "Write CSV data to a string, downloadable file, or uploaded URL. Supports both CsvDataRow format and plain object arrays.",
    category: 'ai',
    color: common_1.BRAND_COLORS.CSV,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.CSV),
    icon: 'csv',
    argsSchema: exports.nativeCsvWriterArgsSchema,
}, exports.nativeCsvWriterResultSchema);
